<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useSeoStore } from '~/stores/useSeoStore';
import LandingSx from "~/components/sx/LandingSx.vue";
import { LandingType } from "~/enums/LandingType";
import { useRefCodeStore } from "~/stores/useRefCodeStore";
import { useHttpReferrer } from "~/composables/useHttpReferrer";
import { usePartnerConfig } from "~/stores/usePartnerConfig";

const { getTitleHome, getDescriptionHome } = useSeoStore();
const { setQueryToCookies, setCodeToStorage, checkCodeFromRoute } = useRefCodeStore();
const { sendPromoCodeAndRef, sendReferrer } = useHttpReferrer();
const { domain } = usePartnerConfig();

const route = useRoute()

useSeoMeta({
  ogTitle: getTitleHome(LandingType.SX),
  ogDescription: getDescriptionHome(LandingType.SX),
  twitterCard: 'summary_large_image',
})

useHead({
  title: getTitleHome(LandingType.SX),
  link: [
    { rel: 'canonical', href: `https://${domain.value}/${route.fullPath}` }
  ],
  meta: [
    { name: 'description', content: getDescriptionHome(LandingType.SX) },
  ],
});

definePageMeta({
  middleware: ['i18n-links'],
});

onBeforeMount(async () => {
  setQueryToCookies();
  setCodeToStorage();
  await checkCodeFromRoute();
  await sendReferrer();
  await sendPromoCodeAndRef();
})
</script>

<template>
  <landing-sx />
</template>